/**
 * Makes a string safe to use as an S3 key.
 * 1. Replaces whitespace with '_'
 * 2. Removes anything that is not a word character, dash, period or forward slash
 *
 * Word characters, `\w`, are equivalent in regex to: `[a-zA-Z0-9_]`
 * @param {string} input
 */
export const sanitizeS3Key = (input: string): string =>
    input.replace(/\s/gi, '_').replace(/[^\w-./]/gi, '');
